import { render, staticRenderFns } from "./SendAuditReminderEmailAction.vue?vue&type=template&id=3b04cd8d&scoped=true&"
import script from "./SendAuditReminderEmailAction.vue?vue&type=script&lang=ts&"
export * from "./SendAuditReminderEmailAction.vue?vue&type=script&lang=ts&"
import style0 from "./SendAuditReminderEmailAction.vue?vue&type=style&index=0&id=3b04cd8d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b04cd8d",
  null
  
)

export default component.exports